module.exports = __webpack_public_path__ + "img/clock.b6533464.svg";